export const formatNumber = (number) => {
  if (isNaN(number)) {
    return '';
  }
  // For very small numbers, show up to 4 decimal places
  if (number < 0.01 && number > 0) {
    return number?.toLocaleString('en-US', {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    });
  }
  return number?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatBigDecimalNumbers = (number, max) => {
  const cleanNumber = typeof number === 'string' ? Number(removeCommas(number)) : Number(number);

  if (isNaN(cleanNumber)) {
    return '';
  }

  if (Number.isInteger(Number(number))) {
    max = 0;
  }

  return cleanNumber?.toLocaleString('en-US', {
    minimumFractionDigits: max === 0 ? 0 : Math.min(max ?? 2, 2),
    maximumFractionDigits: max ?? 6,
  });
};

export const setBalanceWithDecimals = (rawBalance, decimals) => {
  // Return raw number - formatting should be done on display
  return Number(rawBalance) / Math.pow(10, decimals);
};

export const compactNumber = (number, formatThousand = false, decimals = 2) => {
  const formatter = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    minimumFractionDigits: decimals,
  });
  // Detailed formatter for numbers less than 1000
  const detailedFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
  });

  if (!number) {
    return 0;
  }
  if (number >= 1000000 || (formatThousand && number >= 1000)) {
    return formatter.format(number);
  }
  return detailedFormatter.format(number);
};

export const removeCommas = (numberString) => {
  if (typeof numberString !== 'string') {
    return numberString;
  }
  return numberString?.replace(/,/g, '');
};

/**
 * Format a number with commas and specific decimal places
 * @param {number} value - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted number with commas
 */
export const formatWithCommas = (value, decimals = 2) => {
  const num = Number(value);
  if (isNaN(num)) {
    return '0';
  }
  return num.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};
